import { render, staticRenderFns } from "./accessmanagement-add-or-update.vue?vue&type=template&id=5db6b6d2&scoped=true&"
import script from "./accessmanagement-add-or-update.vue?vue&type=script&lang=js&"
export * from "./accessmanagement-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./accessmanagement-add-or-update.vue?vue&type=style&index=0&id=5db6b6d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db6b6d2",
  null
  
)

export default component.exports